import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import PrintPO from "../../../components/utilities/print/default/po";
// middlewares
import AuthMiddleware from "../../../reducers/auth/middleware";
import PrintTakingGoods from "../../../components/utilities/print/default/return-goods";
import TakingGoodsMiddleware from "../../../middleware/modules/warehouse/return-goods";
import PrintReturnGoods from "../../../components/utilities/print/default/return-goods";
import ReturnGoodsMiddleware from "../../../middleware/modules/warehouse/return-goods";

const mapStateToProps = ({ auth, returnGoods }) => ({
  isAuthenticated: auth.isAuthenticated,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  isProcessing: returnGoods.isProcessing,
  dataPrint: returnGoods.printData,
  requestPrint:returnGoods.requestPrint
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => ReturnGoodsMiddleware.getPrint(id),
    },
    dispatch
  );
};

class ReturnGoodsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    requestPrint:PropTypes.bool
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    requestPrint:false
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.id);
  }

  render() {
    // return <PrintTakingGoods {...this.props} />;
    return <PrintReturnGoods {...this.props} />;

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnGoodsContainer);
